/* ===============================
   Popup 25 aniversario · Terral
   =============================== */
(function () {
  const initPopup = (popup) => {
    if (!popup) return;

    const storageKey = popup.dataset.popupKey || `popup25_default`;
    if (localStorage.getItem(storageKey)) return;

    const close = () => {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    };

    const open = () => {
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      localStorage.setItem(storageKey, 'true'); // marcar SOLO cuando se muestra
    };

    // Mostrar con delay
    setTimeout(open, 800);

    const closeBtn = popup.querySelector('.popup-25-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    popup.addEventListener('click', (e) => {
      if (e.target === popup) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  };

  const boot = () => {
    document.querySelectorAll('.popup-25-overlay').forEach(initPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Importante si la sección se carga desde el editor (theme customizer)
  document.addEventListener('shopify:section:load', boot);
})();